{
  "name": "Demo Application",
  "RelatedCompany": "00000000-0000-0000-0000-000000000000",
  "Data": {
    "Manufacturer": { "locale": "de-de", "text": "Manufacturer" }
  },
  "manufacturerURL": "https://manufacturer.de",
  "manufacturerShortURL": "manufacturer.de",
  "demoPageShortUrl": "demo.app",
  "demoPageUrl": "https://demo.page",
  "logoUrl": "/watermarked/logo_small.svg",
  "iconUrl": "/watermarked/logo512.png",
  "screenshotUrl": "/watermarked/test-image.jpg",
  "SoftwareId": "example_sw_id",
  "Positions": {
    "offsite": {
      "lat": 50.111912,
      "lng": 8.547634
    },
    "offsiteClean": {
      "lat": "N 50.1119",
      "lng": "E 8.5476"
    },
    "virtual": {
      "booth": "A1",
      "hall": "1"
    }
  },
  "description": "<p>Description<\/p>"
}
